import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import DrawerHeader from 'components/ui/DrawerHeader';

export const ViewPurchaseOrderHeader = ({ purchaseOrder, toggleViewPurchaseOrder }) => {
  return (
    <DrawerHeader
      onClose={toggleViewPurchaseOrder}
      subTitle={getTranslatedString('landlordPortal.purchaseOrders.header.purchaseOrder')}
      title={purchaseOrder.title}
      status={purchaseOrder.status}
    />
  );
};
